// src/pages/Unauthorized.tsx
import React from "react";

const Unauthorized = () => (
  <div>
    <h2>403 – Nicht autorisiert</h2>
    <p>Du hast keine Berechtigung, auf diese Seite zuzugreifen.</p>
  </div>
);

export default Unauthorized;
